export default "__VITE_ASSET__B3Vbl9V$__"